import React from 'react'
import styled from 'styled-components'
import Swiper from 'react-id-swiper'
import Markdown from 'react-markdown'

import { colors, flex, media } from '../../../constants/style'
import { pages } from '../../../constants/site'
import { getDate, getHashedPath } from '../../../utils'

import { Column, Row } from '../../UI/Grid'
import { RoundImage } from '../../UI/Image'
import { BuyButton, ShowMoreButton } from '../../UI/Button'


const config = {
  spaceBetween: 40,
  slidesPerView: 1,
  shouldSwiperUpdate: true,
  pagination: {
    el: '.swiper-pagination.swiper-pagination--calendar',
    type: 'bullets',
    clickable: true
  },
}

const Wrapper = Column.extend`
  ${media.medium`
    flex-direction: row;
  `}
`

const Content = styled(Column).attrs({
  grow: 0,
})`
  padding: 20px 0 0;
`

const Title = styled.h3`
  color: ${colors.red};
  font-size: 1rem;
  line-height: 1.3rem;
  font-weight: bold;
  margin: 0;
  text-transform: uppercase;
`

const Date = Title.extend`
  font-size: 1.4rem;
  line-height: 1.4rem;
  font-weight: normal;
  text-transform: uppercase;
  margin: 20px 0 0;
`

const Subtitle = styled.h4`
  color: ${colors.red};
  font-size: 1rem;
  line-height: 1.3rem;
  font-weight: normal;
  margin: 0;
  text-transform: uppercase;
`

const fontStyle = `
  font-size: .89rem;
  line-height: 1.4rem;
`

const Label = styled.span`
  ${fontStyle}
  color: ${colors.gray};
  font-weight: bold;
`

const Text = styled.span`
  ${fontStyle}
  color: ${colors.gray};
  font-weight: normal;
`

const FirstColumn = Column.extend`
  margin: 40px 0;
  flex-basis: 40%;
  ${media.medium`
    margin: 0 50px 0 0;
  `}
`

const SecondColumn = Column.extend`
  flex-basis: 60%;
`


const CalendarPreview = ({ data }) => {
  if (!data || !data.length) {
    return (
      <Column align={flex.align.CENTER} justify={flex.justify.CENTER}>
        <Title>Nessun Evento nella data selezionata</Title>
      </Column>
    )
  }

  return (
    <Column grow={0}>
      <Swiper {...config} pagination={config.pagination}>
        {data.map(({ content, image, date, link, officetime, subtitle, title, slug }, index) => (
          <div key={index}>
            <Wrapper>
              <FirstColumn align={flex.align.CENTER} shrink={1}>
                <RoundImage disableLazy src={image}/>
                <Date>{getDate(date)}</Date>
              </FirstColumn>
              <SecondColumn shrink={1}>
                <Title>{title}</Title>
                <Subtitle>{subtitle}</Subtitle>
                <Content>
                  <Text>
                    <Markdown source={`${content.substring(0, 200)}...`} />
                  </Text>
                </Content>
                <Content>
                  <Label>Orario uffici</Label>
                  <Text>{officetime}</Text>
                </Content>
                <Content>
                <a href={link} target="_blank">
                  <BuyButton>Acquista</BuyButton>
                </a>
                </Content>
                <Content>
                <a href={getHashedPath(pages.SPETTACOLI.link, slug)}>
                  <ShowMoreButton>
                    {'Scopri di più >>'}
                  </ShowMoreButton>
                </a>
                </Content>
              </SecondColumn>
            </Wrapper>
          </div>
        ))}
      </Swiper>
    </Column>
  )
}

export default CalendarPreview



// WEBPACK FOOTER //
// ./src/components/Calendar/CalendarPreview/index.js